<template>
    <section class="hero is-gradient-primary is-fullheight">
        <div class="hero-body">
            <div class="container">
                <div class="loginForm">
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title is-secondary">
                                Login
                            </p>
                        </header>
                        <div class="card-content">
                            <form @submit.prevent="tryLogin">
                                <section>
                                    <b-message type="is-danger" v-if="authFailed">
                                        Anmeldung fehlgeschlagen!
                                    </b-message>
                                    <b-field label="Benutzername">
                                        <b-input v-model="form.name"></b-input>
                                    </b-field>
                                    <b-field label="Passwort">
                                        <b-input icon-pack="far" type="password" v-model="form.password"
                                                 password-reveal>
                                        </b-input>
                                    </b-field>
                                    <b-field>
                                        <b-switch v-model="form.keepSession">
                                            Eingeloggt bleiben
                                        </b-switch>
                                    </b-field>

                                    <b-button native-type="submit" :loading="form.loading">Einloggen</b-button>

                                </section>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            return {
                form: {
                    name: '',
                    password: '',
                    keepSession: true
                },
                authFailed: false
            }
        },
        methods: {
            tryLogin() {
                const self = this
                self.form.loading = true
                let auth = {
                    keepSession: self.form.keepSession,
                    user: {}
                }
                fetch(self.$root.env.config.apiURL + 'auth', {
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': self.$root.env.auth.header(self.form.name, self.form.password)
                    })
                })
                    .then(res => {
                        if (res.ok) {
                            return res
                        }
                        self.$root.env.auth = false
                        self.form.password = ''
                        self.authFailed = true
                        self.form.loading = false
                        throw new Error('Network response was not ok. Status: ' + res.status);
                    })
                    .then(user => user.json())
                    .then(user => {
                        if (user.success) {
                            self.authFailed = false
                            self.form.loading = false
                            self.$root.env.auth.login(self.form.name, self.form.password, self.form.keepSession)
                        }
                        self.form.loading = false
                        self.$root.getSettings()
                        self.$root.getEvents()
                    })
                    .catch(function (error) {
                        self.authFailed = true
                        self.form.loading = false
                        console.log('There has been a problem with your fetch operation: ', error.message)
                    })
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .loginForm {
        min-width: 250px;
        max-width: 350px;
        margin: 0 auto;
    }
</style>
